<template>
  <div v-if="this.show_list" class="container-fluid">
    <List></List>
  </div>
  <div v-if="!this.show_list" class="container-fluid">
    <Form></Form>
  </div>
</template>
<script>
import List from '@/views/hiperfarma_campanhas/campanha/List.vue'
import Form from '@/views/hiperfarma_campanhas/pedido/Form.vue'
export default {
  components: { List, Form },
  setup() {
    return {}
  },
  data() {
    return {
      show_list: true,
    }
  },
  created() {
    this.selecionaComponente()
  },
  methods: {
    selecionaComponente() {
      if (this.$route.name === 'Campanhas Hiperfarma') {
        this.show_list = true
      } else {
        this.show_list = false
      }
    },
  },
  watch: {
    $route: {
      deep: true,
      handler: function () {
        this.selecionaComponente()
      },
    },
  },
}
</script>
<style scoped></style>
